module.exports = __webpack_public_path__ + "img/clock-icon.3da9cb94.svg";